import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApplicationService } from '../../services/application.service';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-login',
  templateUrl: './maintenance.component.html'
})
export class MaintenanceComponent implements OnInit {

  constructor(
    private http: HttpClient,
    public applicationService: ApplicationService,
    public userService: UserService,
    public router: Router
  ) { }

  ngOnInit() {
  } 

}
